import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {
  @Output() onConfirm = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<any>();
  @Input() item!: any;
  @Input() title: string = '';
  @Input() deletedName: string = '';
  subscription?: Subscription;
  isDialogOpened: boolean = false;
  constructor(
    private matDialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string, message: string, trueText: string, falseText: string }
  ) { }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  confirm() {
    this.onConfirm.emit(this.item);
  }

  // Only the first click counts, so a double-click can't confirm twice.
  isClosing: boolean = false;
  close(result: boolean) {
    if (this.isClosing) {
      return;
    }
    this.isClosing = true;
    this.dialogRef.close(result);
  }
}
